export default __webpack_public_path__ + "static/media/nourcover.4e6e74cd.jpg";